<template>
    <div class="panel-body">
        <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" :atras="atras" />

        <h5 class="regisTituloUsuario">Informe de Solicitudes Auditor Metabase</h5>

        <br />

        <iframe
            src="/metabase/public/dashboard/79ee416e-6674-49c2-bfaa-21c54c605053"
            frameborder="0"
            width="100%"
            height="600px"
            allowtransparency>
        </iframe>
    </div>
</template>

<script>
import HeaderGeneral from "../../components/HeaderGeneral.vue";

export default {
    name: "InformeAuditor",
    components: {
        HeaderGeneral
    },
    data() {
        return {
            vista: "Informe Solicitudes Auditor",
            carpeta: "Prestadores",
            proveniente: " - Informe Solicitudes",
            atras: false
        };
    }
};
</script>

<style scoped>
.regisTituloUsuario {
    font-size: 20px !important;
    text-align: left !important;
    font-weight: 100 !important;
    color: var(--blue-violet);
}
</style>
